import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import { saveAs } from 'file-saver';
// @mui
import {
  Typography,
  Box,
  Stack,
  TextField,
  Button,
  Modal,
  Autocomplete,
  IconButton,
  Paper,
  Container,
} from '@mui/material';

// Icons
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';

import VisibilityIcon from '@mui/icons-material/Visibility';
import BlockIcon from '@mui/icons-material/Block';
import AddCard from '@mui/icons-material/AddCard';

import CalendarMonth from '@mui/icons-material/CalendarMonth';

// Stepper
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

// api
import { getFluxogramas, getAnexos, getUnoAnexo, deleteUnoAnexo, getTipoAnexo, updateChamado, updateProposta, updateGenericData, getUsuarios, getEmpresaAtual } from './api';
import ModalMensagem from './ModalMensagem';
import ModalMudaFluxo from './ModalMudalFluxo';
import ModalAtividadade from './ModalAtividade';
import AtividadesPainel from './AtividadesPainel';
import EditProposta from './EditProposta';
import ModalDesconto from './ModalDesconto';

import { enviaMensagem } from './apiWpp';
import ModalRejeitarProposta from './ModalRejeitarProposta';
import ModalResponsavel from './ModalResponsavel';
import ModalConfirmacao from './ModalConfirmacao';
import ModalPagamento from './ModalPagamento';
import ModalMontador from './ModalMontador';
import ModalValorMontagem from './ModalValorMontagem';
import ModalTipoContratante from './ModalTipoContratante';
import ModalAddAnexo from './ModalAddAnexo';
import ModalValidaAnexos from './ModalValidaAnexos';
import ModalAddAgenda from './ModalAddAgenda';
import ModalPropostaPersonalizada from './ModalPropostaPersonalizada';
import ModalAlocarVendedor from './ModalAlocarVendedor';
import ModalPagamentoIndicador from './ModalPagamentoIndicador';
import ModalParecerAcesso from './ModalParecerAcesso';
import ModalEmissaoDocumentacao from './ModalEmissaoDocumentacao';
import ModalProjetoConcluido from './ModalProjetoConcluido';
import ModalFormularioMontagem from './ModalFormularioMontagem';
import ModalVerEquipamentos from './ModalVerEquipamentos';
import { cores, coresHex } from '../styles/styleUtils';

// Modal ---------------------------------
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '85vw',
  height: '100vh',
  '@media screen and (max-width: 600px)': {
    width: '100vw', // Width de 100% para telas de celulares
    height: '100vh',
  },
  bgcolor: 'transparent',
  border: `1px solid ${cores.chumbo}`,
  borderTop: `4px solid ${cores.laranja}`,
  boxShadow: 24,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
};

// Tema local TriAxis: deixa os botões "contained" padrão (antes pretos) em laranja,
// sem afetar os botões com cor explícita (error/success/sx backgroundColor).
// Usa `coresHex` (e não `cores`): o createTheme do MUI resolve a cor com
// decomposeColor, que não entende `var(--...)` e lançaria erro em runtime.
const temaMarca = createTheme({
  palette: {
    primary: { main: coresHex.laranja, dark: coresHex.laranjaEscuro, contrastText: coresHex.textoClaro },
  },
});

// Faixa de título dos painéis (Backlog/Atividades/Anexos) no padrão escuro
const sxTituloPainel = {
  width: '100%',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  color: cores.textoClaro,
  borderRadius: 2,
  py: 0.5,
};

const sxFontBotaoMobile = {
  '@media screen and (max-width: 600px)': {
    fontSize: 10,
  },
};

const syleinformation = {
  width: '30px', // Ajuste da largura
  height: '30px', // Ajuste da altura
  minWidth: 'unset', // Remove o minWidth padrão do MUI
  padding: 0, // Remove o padding
  mt: 2,
  mb: 2,
  borderRadius: '50%', // Deixa o botão circular
  fontSize: '16px', // Define o tamanho da fonte para o ícone
  lineHeight: 1, // Centraliza verticalmente o conteúdo
  borderColor: 'grey', // Cor da borda, para dar aparência de ícone
  color: 'grey', // Cor do texto
  '&:hover': {
    borderColor: 'darkgrey', // Cor da borda ao passar o mouse
    color: 'darkgrey', // Cor do texto ao passar o mouse
  },
};
// Modal ---------------------------------

// Stepper ------------------------------------
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: 'var(--marca-primaria)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: 'var(--marca-primaria)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: 'var(--marca-primaria)',
  }),
  '& .QontoStepIcon-completedIcon': {
    color: 'var(--marca-primaria)',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? <Check className="QontoStepIcon-completedIcon" /> : <div className="QontoStepIcon-circle" />}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
};

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundImage: 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage: 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <SettingsIcon />,
    2: <GroupAddIcon />,
    3: <VideoLabelIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};
// Stepper -----------------------------------

// const emptyProposta = {etapa: {id: 0}}

// ----------------------------------------------------------------------
// eslint-disable-next-line
const EditFluxo = React.forwardRef((props, ref) => {
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
  const currentLocation = useLocation();

  const [proposta, setProposta] = useState(props.proposta);

  // Identifica o tipo de produto para adaptar fluxos
  const isBombeamento       = proposta?.produto?.nome === 'Sistema de Bombeamento';
  const isOffGrid           = proposta?.produto?.nome === 'Gerador Off-Grid';
  const isFluxoSimplificado = isBombeamento || isOffGrid;
  const isServico           = proposta?.produto?.nome === 'Serviços' || proposta?.produto?.nome === 'Proposta de Serviços';

  const [anexo, setAnexo] = useState([]);

  // const fluxogramas1 = await getFluxogramas();

  const [steps, setSteps] = useState(null);

  const [modalMensagem, setModalMensagem] = useState(false);
  const [modalMudaFluxo, setModalMudaFluxo] = useState(false);
  const [modalAtividade, setModalAtividade] = useState(false);
  const [modalRejeitar, setModalRejeitar] = useState(false);
  const [modalResponsavel, setModalResponsavel] = useState(false);
  const [modalConfirmacaoDelete, setModalConfirmacaoDelete] = useState(false);
  const [modalAnexo, setModalAnexo] = useState(false);
  const [modalPagamento, setModalPagamento] = useState(false);
  const [modalMontador, setModalMontador] = useState(false);
  const [modalValorMontagem, setModalValorMontagem] = useState(false);
  const [modalTipoContratante, setModalTipoContratante] = useState(false);
  const [modalAddAnexo, setModalAddAnexo] = useState(false);
  const [modalValidaAnexos, setModalValidaAnexos] = useState(false);
  const [modalDesconto, setModalDesconto] = useState(false);
  const [modalPersonalizado, setModalPersonalizado] = useState(false)
  const [modalAlocar, setModalAlocar] = useState(false)

  const [visualizaProposta, setVisualizaProposta] = useState(false);
  const [trocaDisjuntor, setTrocaDisjuntor] = useState(null);

  // Empresa atual — usada para preencher {nomeempresa} nas mensagens automáticas de WhatsApp
  const [empresaAtual, setEmpresaAtual] = useState(null);
  useEffect(() => {
    getEmpresaAtual(proposta?.user?.unidade?._id)
      .then((emp) => setEmpresaAtual(emp))
      .catch(() => setEmpresaAtual(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCloseVisualiza = () => {
    setVisualizaProposta(false);
  };

  const [fluxogramas, setFluxogramas] = useState([]);
  useEffect(() => {
    fetchFluxos();
  }, [props.proposta]);
  const fetchFluxos = async () => {
    const resultado = await getFluxogramas();
    setFluxogramas(resultado);
  };

  /*
  useEffect(() => {
    if (props.proposta) {
      setProposta(props.proposta);
    }
  }, [props.proposta]);
  */

  useEffect(() => {
    const fetchAnexos = async () => {
      try {
        const resultado = await getAnexos(props.proposta);
        if (resultado) {
          setAnexo(resultado);
        }
      } catch (error) {
        console.log('Erro ao buscar anexos:', error);
      }
    };
    fetchAnexos();
  }, [props.proposta]);

  useEffect(() => {
    setSteps(fluxogramas.find((fluxo) => fluxo.id === props.proposta.fluxo.id) || null);
  }, [fluxogramas, proposta.fluxo?.id]);

  const onClose = () => {
    setProposta(null);
    setAnexo(null);
    setTrocaDisjuntor(null);
    props.onClose();
  };

  // Ao clicar no confirm executa a funcao da props onConfirm retornando produto para o objeto pai
  const handleConfirm = () => {
    if (proposta.etapa.nome === 'Finalização') {
      const newProposta = { ...proposta };
      newProposta.finalizado = { nome: 'Finalizado', data: new Date() };
      props.onConfirm(newProposta, anexo);
      onClose();
      return;
    }
    props.onConfirm(proposta, anexo);
    onClose();
  };

  const handleNext = async () => {
    //
    const resultado = await fluxogramas.find((value) => value.id === proposta.fluxo.id).etapas[proposta.etapa.id + 1];
    if (resultado?.enviamensagem) {
      const { mensagem, destino } = resultado;
      setModalMensagem(true);
      await enviaMensagem(mensagem, destino, proposta, (enviadoComSucesso, mensagem) => {
        setModalMensagem(false);
        if (!enviadoComSucesso) {
          window.alert('Erro ao enviar mensagem');
        }
      });
    }

    // Verifica se a proxima etapa vai ser Confeccao Projeto para abrir o modal do responsavel
    if (proposta.fluxo.id === 3 && resultado?.id === 2) {
      setModalResponsavel(true);
    }

    // NOVO (deployment Marcki): mesmo comportamento do fluxo de Engenharia
    // (fluxo.id === 3) acima, agora também para o fluxo de Engenharia de
    // Serviços (fluxo.id === 100000000) — ao avançar para "Execução do
    // serviço" (etapa id 2, ver seed-fluxograma-engenharia-servico.js),
    // abre o mesmo modal para selecionar o responsável pela execução.
    if (proposta.fluxo.id === 100000000 && resultado?.id === 2) {
      setModalResponsavel(true);
    }

    // Verifica se a proxima etapa vai ser Assinar Contrato para abrir o modal do pagamento
    if (proposta.fluxo.id === 2 && resultado?.id === 5) {
      setModalPagamento(true);
    }

    // Verifica se a proxima etapa vai ser Comissionamento para abrir o modal do valor
    // Etapa 3 = Montagem; ao avançar para etapa 4 = Comissionamento, pede valor se montador externo
    if (proposta.fluxo.id === 4 && proposta.etapa.id === 3 && proposta.montador?.montadorexterno) {
      setModalValorMontagem(true);
    }

    // Verifica se a proxima etapa vai ser Coleta de Dados para abrir o modal do Tipo Contratante
    if (proposta.fluxo.id === 2 && proposta.etapa.id === 5) {
      setModalTipoContratante(true);
    }

    // Verifica se a esta na Coleta de Dados para validar os anexos
    if (proposta.fluxo.id === 2 && proposta.etapa.id === 6) {
      const anexosValidos = await validaAnexos();
      if (!anexosValidos) {
        window.alert(
          'Anexos obrigatórios não informados, clique no ícone ao lado de adicionar para verificar os anexos'
        );
        return;
      }
    }

    // Abre modal ao entrar na etapa Parecer de Acesso (fluxo Engenharia) — apenas on-grid
    if (proposta.fluxo.id === 3 && proposta.etapa.id === 4 && !isFluxoSimplificado) {
      setModalParecerAcesso(true);
      // Não retorna — deixa avançar normalmente para a etapa 5
    }

    // Bloqueia avanço etapa "Projeto Concluído" (id=4) bombeamento/off-grid — NF + Valor + Diagrama
    if (proposta.fluxo.id === 3 && proposta.etapa.id === 4 && isFluxoSimplificado) {
      const temNF       = anexo?.some((a) => a.tipo?.nome === 'Nota Fiscal de Projeto');
      const temDiagrama = anexo?.some((a) => a.tipo?.nome === 'Diagrama Unifilar');
      if (!proposta.valorprojeto) {
        window.alert('Informe o Valor do Projeto antes de avançar da etapa Projeto Concluído.');
        return;
      }
      if (!temNF) {
        window.alert('Anexe a Nota Fiscal de Projeto antes de avançar da etapa Projeto Concluído.');
        return;
      }
      if (!temDiagrama) {
        window.alert('Anexe o Diagrama Unifilar antes de avançar da etapa Projeto Concluído.');
        return;
      }
    }

    // Bloqueia avanço da etapa Parecer de Acesso sem valor e anexos — apenas on-grid
    // Serviço executado internamente (proposta.servicoInterno) dispensa Valor e NF;
    // o Parecer de Acesso da distribuidora continua obrigatório sempre.
    if (proposta.fluxo.id === 3 && proposta.etapa.id === 5 && !isFluxoSimplificado) {
      const temValor = proposta.servicoInterno || (proposta.valorservico && proposta.valorservico > 0);
      const temNF = proposta.servicoInterno || anexo?.some((a) => a.tipo?.nome === 'Nota Fiscal de Projeto');
      const temParecer = anexo?.some((a) => a.tipo?.nome === 'Parecer de Acesso');
      if (!temValor) {
        window.alert('Informe o valor do serviço antes de avançar.');
        setModalParecerAcesso(true);
        return;
      }
      if (!temNF) {
        window.alert('Anexe a Nota Fiscal antes de avançar.');
        setModalParecerAcesso(true);
        return;
      }
      if (!temParecer) {
        window.alert('Anexe o Parecer de Acesso da distribuidora antes de avançar.');
        setModalParecerAcesso(true);
        return;
      }
      if (proposta.inversaoFluxo) {
        const opcaoSel = (proposta.opcoesLiberadas || []).find(
          (o) => String(o.opcao) === String(proposta.opcaoSelecionada)
        );
        const potenciaLiberada = Number(opcaoSel?.potenciaLiberada) || 0;
        if (Number(proposta.novaPotencia) > potenciaLiberada) {
          window.alert('A Nova Potência informada é maior que a Potência Liberada da opção selecionada. Corrija antes de avançar.');
          setModalParecerAcesso(true);
          return;
        }
        const temAprovacaoModificacao = anexo?.some((a) => a.tipo?.nome === 'Aprovação da Modificação');
        if (!temAprovacaoModificacao) {
          window.alert('Anexe a Aprovação da Modificação (CEMIG) antes de avançar, pois a Inversão de Fluxo está marcada.');
          setModalParecerAcesso(true);
          return;
        }
      }
    }

    // Bloqueia avanço da etapa Formulário de Montagem sem NF e Foto
    if (proposta.fluxo.id === 4 && proposta.etapa.id === 5) {
      const temNFMontagem = anexo?.some((a) => a.tipo?.nome === 'Nota Fiscal de Montagem');
      const temFotoMontagem = anexo?.some((a) => a.tipo?.nome === 'Foto de Montagem');
      if (!temNFMontagem) {
        window.alert('Anexe a Nota Fiscal de Montagem antes de avançar.');
        setModalFormularioMontagem(true);
        return;
      }
      if (!temFotoMontagem) {
        window.alert('Anexe ao menos uma Foto de Montagem antes de avançar.');
        setModalFormularioMontagem(true);
        return;
      }
    }

    // Verifica se a proxima etapa vai ser solicitação de vistoria — apenas on-grid
    if (proposta.fluxo.id === 4 && proposta.etapa.id === 6 && !isFluxoSimplificado) {
      await enviaMensagem(
        'Solicitar Vistoria da obra — *{nomecliente}*',
        [proposta.responsavel.telefone],
        proposta,
        (enviadoComSucesso, mensagem) => {
          setModalMensagem(false);
          if (!enviadoComSucesso) {
            window.alert('Erro ao enviar mensagem');
            return;
          }
          window.alert('Enviado mensagem para o responsável do projeto');
        }
      );
    }

    // Fluxo Simplificado (bombeamento/off-grid): "Envio Montagem" (id=5) — abre modal montador
    if (proposta.fluxo.id === 3 && proposta.etapa.id === 5 && isFluxoSimplificado) {
      setModalMontador(true);
      return;
    }
    // On-grid: "Projeto de Implantação" (id=6) — exige Diagrama antes de ir para montagem
    if (proposta.fluxo.id === 3 && proposta.etapa.id === 6 && !isFluxoSimplificado) {
      const temUnifilar = anexo?.some((a) => a.tipo?.nome === 'Diagrama Unifilar');
      if (!temUnifilar) {
        window.alert('Anexe o Diagrama Unifilar antes de avançar para o fluxo de Montagem.');
        return;
      }
      setModalMontador(true);
      return;
    }

    // verifica se é a ultima etapa e se o fluxo permite mudar de fluxo
    if (proposta.etapa?.id + 1 > steps.etapas.length - 1 && proposta.fluxo.id >= 2 && proposta.fluxo.id < 4) {
      setModalMudaFluxo(true);
      return;
    }
    // verifica se é a ultima etapa do ultimo fluxo
    // Fluxo 4 (Montagem) agora tem 11 etapas: ids 0 a 10
    if (
      (proposta.fluxo.id === 4 && proposta.etapa.id === 10) ||
      (proposta.fluxo.id === 80 && proposta.etapa.id === 5) ||
      (proposta.fluxo.id === 90 && proposta.etapa.id === 5) ||
      (proposta.fluxo.id === 100000000 && proposta.etapa.id === 6)
    ) {
      window.alert('Não encontrado próximo fluxo, não esqueça de salvar');
      return;
    }

    // Backlog---
    const newBacklog = [...proposta.backlog];
    const hasFluxo = newBacklog.find((fluxo) => fluxo.id === proposta.fluxo.id);
    if (hasFluxo) {
      const hasEtapa = hasFluxo.etapas.find((etapa) => etapa.id === proposta.etapa.id);
      if (hasEtapa) {
        hasEtapa.data = new Date();
      } else {
        hasFluxo.etapas.push({
          id: steps.etapas[proposta.etapa?.id].id,
          nome: steps.etapas[proposta.etapa?.id].nome,
          data: new Date(),
        });
      }
    } else {
      const fluxo = fluxogramas.find((fluxo) => fluxo.id === proposta.fluxo.id);
      newBacklog.push({
        id: fluxo.id,
        nome: fluxo.nome,
        etapas: [
          { id: steps.etapas[proposta.etapa?.id].id, nome: steps.etapas[proposta.etapa?.id].nome, data: new Date() },
        ],
      });
    }

    // atualiza proposta
    setProposta({ ...proposta, etapa: steps.etapas[proposta.etapa?.id + 1], backlog: newBacklog });
  };

  const handleBack = () => {
    setProposta({ ...proposta, etapa: steps.etapas[proposta.etapa?.id - 1] });
  };

  const closeModalMensagem = () => {
    setModalMensagem(false);
  };

  const closeModalAtividade = () => {
    setModalAtividade(false);
  };

  const closeModalMudaFluxo = () => {
    setModalMudaFluxo(false);
  };

  const handleMudaFluxo = async () => {
    // Serviços saem da Coleta de Dados (Vendas, fluxo 2) direto para a Engenharia de Serviços (fluxo 100000000),
    // em vez do fluxo de Engenharia dos produtos (fluxo 3).
    const proximoFluxoId = (isServico && proposta.fluxo.id === 2) ? 100000000 : proposta.fluxo.id + 1;
    const resultado = fluxogramas.find((value) => value.id === proximoFluxoId).etapas[0];
    if (resultado?.enviamensagem) {
      const { mensagem, destino } = resultado;
      setModalMensagem(true);
      await enviaMensagem(mensagem, destino, proposta, (enviadoComSucesso, mensagem) => {
        setModalMensagem(false);
        if (!enviadoComSucesso) {
          window.alert('Erro ao enviar mensagem');
        }
      });
    }
    // Backlog---
    const newBacklog = [...proposta.backlog];
    const hasFluxo = newBacklog.find((fluxo) => fluxo.id === proposta.fluxo.id);
    if (hasFluxo) {
      const hasEtapa = hasFluxo.etapas.find((etapa) => etapa.id === proposta.etapa.id);
      if (hasEtapa) {
        hasEtapa.data = new Date();
      } else {
        hasFluxo.etapas.push({
          id: steps.etapas[proposta.etapa?.id].id,
          nome: steps.etapas[proposta.etapa?.id].nome,
          data: new Date(),
        });
      }
    } else {
      const fluxo = fluxogramas.find((fluxo) => fluxo.id === proposta.fluxo.id);
      newBacklog.push({
        id: fluxo.id,
        nome: fluxo.nome,
        etapas: [
          { id: steps.etapas[proposta.etapa?.id].id, nome: steps.etapas[proposta.etapa?.id].nome, data: new Date() },
        ],
      });
    }
    // Atualize o estado da proposta
    const updatedProposta = {
      ...proposta, // Use o estado atual como base
      fluxo: fluxogramas.find((fluxo) => fluxo.id === proximoFluxoId),
      etapa: fluxogramas.find((fluxo) => fluxo.id === proximoFluxoId).etapas[0],
    };

    // Execute a função handleConfirm após a atualização do estado
    handleConfirm2(updatedProposta);

    // Atualize o estado uma vez, após todas as operações terem sido concluídas
    setProposta(updatedProposta);

    closeModalMudaFluxo();
    // handleConfirm()
  };

  const handleConfirm2 = (updatedProposta) => {
    props.onConfirm(updatedProposta, anexo);
    onClose();
  };

  const addNewAnexo = (newanexo) => {
    const newArrayAnexos = [...anexo];
    if ('index' in newanexo) {
      const { index, ...restoDoAnexo } = newanexo;
      newArrayAnexos[index] = { ...restoDoAnexo, ...(proposta.fluxo.id === 4 && { instalacao: true }) };
    } else {
      newArrayAnexos.push({ ...newanexo, ...(proposta.fluxo.id === 4 && { instalacao: true }) });
    }

    setAnexo(newArrayAnexos);
    setModalAddAnexo(false);
    setAnexoToChange(null);
  };

  const handleChangeAnexo = (anexo) => {
    setAnexoToChange(anexo);
    setModalAddAnexo(true);
  };

  // Baixar Arquivo Base64 ---------------------
  async function downloadAnexo(anexo) {
    if (anexoToChange !== false) {
      return;
    }
    const anexoResult = await getUnoAnexo({ _id: anexo._id });
    // console.log(anexoResult);
    // Verifique se o anexo tem dados Base64 válidos
    if (anexoResult && anexoResult.base64) {
      // Divide a string Base64 em um array usando a vírgula como delimitador
      const parts = anexoResult.base64.split(',');

      if (parts.length === 2) {
        // A primeira parte contém o tipo de arquivo
        const contentType = parts[0].split(';')[0];
        const fileType = contentType.split('/')[1];

        // A segunda parte contém os dados Base64
        const base64String = parts[1];

        // Cria um Blob a partir do Base64
        const blob = b64toBlob(base64String, fileType);

        // Use o file-saver para salvar o Blob como arquivo
        // console.log(fileType)
        let extension = '';
        if (fileType === 'plain') {
          extension = 'txt';
        } else if (fileType === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          extension = 'xlsx';
        } else {
          // Se não for um tipo de arquivo conhecido, use a extensão padrão
          extension = fileType;
        }

        saveAs(blob, `${anexoResult.nome}.${extension}`);
      }
    }
  }

  function b64toBlob(base64, contentType) {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  const handleSalvarAtividade = (atividade) => {
    const newArray = [...proposta.atividades];
    newArray.push({
      ...atividade,
      // `msg` mantido por compatibilidade com qualquer lugar do sistema que
      // ainda leia o texto pronto da atividade (ex.: exports/notificações).
      msg: `${atividade.tipo}${atividade.descricao ? `: ${atividade.descricao}` : ''}`,
      ...(proposta.fluxo.id === 4 && { instalacao: true }),
    });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...proposta, // Use o estado atual como base
      atividades: newArray,
    };
    // Atualize o estado uma vez, após todas as operações terem sido concluídas
    setProposta(updatedProposta);
    closeModalAtividade();
  };

  const rejeitarProposta = () => {
    const newProposta = { ...proposta };
    newProposta.finalizado = { nome: 'Rejeitado', data: new Date() };
    // setProposta({...proposta, finalizado: {nome: 'Rejeitado', data: new Date()}})
    props.onConfirm(newProposta, anexo);
    onClose();
  };

  const pagamentoProposta = (pagamento) => {
    const newProposta = { ...proposta, formapagamento: pagamento };

    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      tipo: 'Forma de Pagamento',
      descricao: `${pagamento.nome}${pagamento.obs ? ` - OBS.: ${pagamento.obs}` : ''}`,
      usuario: usuarioLogado,
      proximaAcao: false,
      msg: `Adicionado ${pagamento.nome} como forma de pagamento. ${pagamento.obs ? `OBS.: ${pagamento.obs}` : ''}`,
    });
    if (proposta.origem?.nome === 'Indicação') {
      const valorIndicacao = proposta.tipoindicacao?.valor
        ? proposta.tipoindicacao.valor
        : proposta.valor * (proposta.percentualindicacao / 100);
      newArray.push({
        data: new Date(),
        msg: `Indicação - Nome: ${proposta.indicador.nome}, Celular: ${proposta.indicador.telefone}, Chave Pix: ${proposta.indicador.chavepix}, Valor: ${valorIndicacao}`,
      });
    }
    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
    };
    props.onConfirm(updatedProposta, anexo);
    onClose();
  };

  const solicitarDesconto = async (desconto) => {
    const chamado = {
      pid: proposta._id,
      tipo: 1,
      aberto: true,
      status: 'Pendente',
      dados: desconto,
      data: new Date(),
      userabertura: usuarioLogado,
      userdestino: usuarioLogado,
    };
    await updateChamado(chamado);

    const newArray = [...proposta.atividades];
    newArray.push({
      data: new Date(),
      tipo: 'Desconto',
      descricao: `Valor Solicitado: ${desconto.valorsolicitado}, Forma de Pagamento: ${desconto.formapagamento.nome}${desconto.obs ? ` - OBS.: ${desconto.obs}` : ''}`,
      usuario: usuarioLogado,
      proximaAcao: false,
      msg: `Solicitado desconto - Valor Solicitado: ${desconto.valorsolicitado}, Forma de Pagamento: ${desconto.formapagamento.nome} OBS.: ${desconto.obs}`,
    });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...proposta, // Use o estado atual como base
      atividades: newArray,
    };

    // Notifica o(s) supervisor(es) da mesma unidade do vendedor da proposta
    try {
      const mesmaUnidade = (u1, u2) => {
        if (!u1 || !u2) return false;
        if (u1._id && u2._id) return String(u1._id) === String(u2._id);
        if (u1.id !== undefined && u2.id !== undefined) return u1.id === u2.id;
        return !!u1.nome && u1.nome === u2.nome;
      };
      const todosUsuarios = await getUsuarios();
      const supervisores = (todosUsuarios || []).filter(
        (u) => u.supervisor && mesmaUnidade(u.unidade, proposta.user?.unidade)
      );
      if (supervisores.length > 0) {
        await enviaMensagem(
          'Desconto solicitado pelo usuário — *{nomeusuario}*. Acesse a plataforma para mais informações',
          supervisores.map((s) => s.telefone),
          { ...proposta, user: usuarioLogado },
          (enviadoComSucesso) => {
            if (!enviadoComSucesso) {
              window.alert('Erro ao enviar mensagem ao supervisor');
            }
          }
        );
      } else {
        console.log('Nenhum supervisor encontrado na unidade do vendedor para notificar do desconto.');
      }
    } catch (e) {
      console.error('Erro ao localizar supervisor para notificação de desconto:', e);
    }

    props.onConfirm(updatedProposta, anexo);
    onClose();
  };

  const cancelarPagamento = () => {
    // atualiza proposta
    setProposta({ ...proposta, etapa: steps.etapas[proposta.etapa?.id - 1] });
    setModalPagamento(false);
    setModalValorMontagem(false);
  };

  const cancelarTipoContratante = () => {
    // atualiza proposta
    setProposta({ ...proposta, etapa: steps.etapas[proposta.etapa?.id - 1] });
    setModalTipoContratante(false);
  };

  const valorMontagem = (pagamento) => {
    const newProposta = { ...proposta, valormontagem: pagamento };

    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      msg: `Adicionado valor de montagem: ${parseFloat(pagamento).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })}`,
      instalacao: true,
    });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
    };
    props.onConfirm(updatedProposta, anexo);
    onClose();
  };

  const handletipoContratante = (valor) => {
    const newProposta = { ...proposta, tipocontratante: valor.id };

    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      tipo: 'Tipo de Contratante',
      descricao: valor.nome,
      usuario: usuarioLogado,
      proximaAcao: false,
      msg: `Adicionado tipo contratante: ${valor.nome}`,
    });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
    };
    props.onConfirm(updatedProposta, anexo);
    onClose();
  };

  const rejeitarProposta2 = (obs) => {
    const newProposta = { ...proposta };
    newProposta.finalizado = { nome: 'Rejeitado', data: new Date(), obs };
    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      msg: `Proposta rejeitada - Motivo: ${proposta.motivoRejeicao?.nome} - OBS.: ${obs}`,
    });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
    };
    props.onConfirm(updatedProposta, anexo);
    onClose();
  };

  const responsavelProposta = async (usuario) => {
    const newProposta = { ...proposta, responsavel: usuario };

    const newArray = [...newProposta.atividades];
    newArray.push({ data: new Date(), msg: `Adicionado ${usuario.nome} como responsável do projeto` });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
    };

    await enviaMensagem(
      'A empresa *{nomeempresa}* enviou um novo projeto. Acesse a plataforma para maiores informações',
      [usuario.telefone],
      { ...updatedProposta, empresa: empresaAtual },
      (enviadoComSucesso) => {
        if (!enviadoComSucesso) {
          window.alert('Erro ao enviar mensagem para o engenheiro alocado');
        }
      }
    );

    props.onConfirm(updatedProposta, anexo);
    onClose();
  };

  const montadorProposta = async (usuario) => {
    const newProposta = { ...proposta, montador: usuario };

    const newArray = [...newProposta.atividades];
    newArray.push({ data: new Date(), msg: `Adicionado ${usuario.nome} como montador do projeto` });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
    };
    proposta.montador = usuario;
    proposta.atividades = newArray;

    await handleMudaFluxo();
    await enviaMensagem(
      'A empresa *{nomeempresa}* enviou uma nova montagem. Acesse a plataforma para maiores informações',
      [usuario.telefone],
      { ...proposta, empresa: empresaAtual },
      (enviadoComSucesso, mensagem) => {
        setModalMensagem(false);
        if (!enviadoComSucesso) {
          window.alert('Erro ao enviar mensagem para montador');
        }
      }
    );
  };

  useEffect(() => {
    verificarDisjuntor();
  }, [proposta.kit]);
  const verificarDisjuntor = () => {
    if (
      (proposta.produto._id === '65089a46326edddd6ff36604' &&
        proposta.disjuntorcliente?.tipodisjuntor?.id < proposta.kit?.disjuntorminino?.tipodisjuntor?.id) ||
      proposta.disjuntorcliente?.potenciadisjuntor?.valor < proposta.kit?.disjuntorminino?.potenciadisjuntor?.valor
    ) {
      setTrocaDisjuntor(true);
    }
  };

  // delete anexo
  const [anexoToDelete, setAnexoToDelete] = useState(null);

  const handleDelete = (anexo) => {
    setAnexoToDelete(anexo);
    setModalConfirmacaoDelete(true);
  };

  const closeModalConfirmacaDelete = () => {
    setAnexoToDelete(null);
    setModalConfirmacaoDelete(false);
  };

  const confirmDeleteAnexo = async () => {
    if (!anexoToDelete._id) {
      const newArray = [...anexo];
      newArray.splice(anexoToDelete.index, 1);
      setAnexo(newArray);
      closeModalConfirmacaDelete();
      return;
    }

    const result = await deleteUnoAnexo(anexoToDelete);
    if (result) {
      closeModalConfirmacaDelete();
      const resultado = await getAnexos(props.proposta);
      if (resultado) {
        setAnexo(resultado);
      }
    }
  };

  // altera anexo
  const [anexoToChange, setAnexoToChange] = useState(false);
  const [newName, setNewName] = useState('');

  const changeName = (event) => {
    setNewName(event.target.value);
  };

  const confirmName = () => {
    // console.log(anexo)
    const newArrayAnexos = [...anexo.anexos];
    newArrayAnexos[anexoToChange].nome = newName;
    if (!newArrayAnexos[anexoToChange].base64) {
      newArrayAnexos[anexoToChange].alterado = true;
    }
    setAnexo({ ...anexo, anexos: newArrayAnexos });
    setAnexoToChange(false);
    setNewName('');
  };

  const cancelName = () => {
    setAnexoToChange(false);
    setNewName('');
  };

  const validaAnexos = async () => {
    console.log('validaAnexos - produto:', proposta?.produto?.nome, '| isOffGrid:', isOffGrid, '| isBombeamento:', isBombeamento);
    // Serviços não têm anexos obrigatórios (podem ter tipos específicos, mas nenhum é bloqueante)
    if (proposta?.produto?.nome === 'Serviços' || proposta?.produto?.nome === 'Proposta de Serviços') {
      return true;
    }
    const tiposanexos = await getTipoAnexo();
    const anexosVerificar = anexo;
    const propostaTipoContratante = proposta.tipocontratante;

    // 'todos'       = on-grid, bombeamento e off-grid
    // 'ambos'       = retrocompatibilidade (equivale a 'todos')
    // 'ongrid'      = apenas on-grid
    // 'bombeamento' = apenas bombeamento
    // 'offgrid'     = apenas off-grid
    const tiposObrigatorios = tiposanexos.filter((tipo) => {
      if (!tipo.obrigatorio) return false;
      if (tipo.tipocontratante && tipo.tipocontratante !== propostaTipoContratante) return false;
      if (!tipo.tipoproposta || tipo.tipoproposta === 'todos' || tipo.tipoproposta === 'ambos') return true;
      if (isBombeamento && tipo.tipoproposta === 'bombeamento') return true;
      if (isOffGrid    && tipo.tipoproposta === 'offgrid')     return true;
      if (!isFluxoSimplificado && tipo.tipoproposta === 'ongrid') return true;
      return false;
    });

    // Verifica se cada tipo obrigatório está presente em anexosVerificar pelo _id
    const faltando = tiposObrigatorios.filter(
      (tipoObrigatorio) => !anexosVerificar.some((anexo) => anexo.tipo._id === tipoObrigatorio._id)
    );

    if (faltando.length > 0) {
      return false; // Retorna false se faltarem anexos obrigatórios
    }

    return true; // Retorna true se todos os anexos obrigatórios estiverem presentes
  };

  const handleAutoCompleteChange = (idName, name, value) => {
    setProposta({
      ...proposta,
      [idName]: value?._id,
      [name]: value,
    });
  };

  const [modalAddAgenda, setModalAddAgenda] = useState(false);

  const handleAddAgenda = async (agenda) => {
    const newProposta = { ...proposta };
    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      tipo: 'Agenda',
      descricao: agenda.descricaoAgenda,
      usuario: agenda.usuario,
      proximaAcao: true,
      msg: `Adicionado agenda - Usuário: ${agenda.usuario.nome} - Descrição: ${agenda.descricaoAgenda}`,
    });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
    };

    if (agenda.usuario?.telefone) {
      await enviaMensagem(
        'Você possui agendamentos hoje. Acesse a plataforma para maiores informações',
        [agenda.usuario.telefone],
        proposta,
        (enviadoComSucesso) => {
          if (!enviadoComSucesso) {
            window.alert('Erro ao enviar mensagem de agenda ao usuário');
          }
        }
      );
    }

    props.onConfirm(updatedProposta, anexo);
    setModalAddAgenda(false)
  }

  // Emissão de Documentação (serviços): grava dados da NS nas atividades ao salvar.
  const handleConfirmEmissaoDoc = async (dados) => {
    const usuario = JSON.parse(localStorage.getItem('userData'));
    const fmtData = (d) => (d ? new Date(`${d}T00:00:00`).toLocaleDateString('pt-BR') : '-');

    // A agenda só é criada quando ainda não foi criada para esta NS + data de expiração.
    // O marcador (agendaExpiracaoRef) é gravado SÓ após a criação, então o 'Adicionar Documento'
    // (que apenas preserva os campos) não bloqueia a criação.
    const ref = `${dados.numeroNS}|${dados.dataExpiracao}`;
    const criarAgenda =
      dados.possuiDocAprovado &&
      dados.numeroNS &&
      dados.dataExpiracao &&
      proposta.emissaoDoc?.agendaExpiracaoRef !== ref;

    console.log('Emissão Doc — decisão de agenda:', {
      possuiDocAprovado: dados.possuiDocAprovado,
      numeroNS: dados.numeroNS,
      dataExpiracao: dados.dataExpiracao,
      refAtual: proposta.emissaoDoc?.agendaExpiracaoRef,
      ref,
      criarAgenda,
    });

    if (criarAgenda) {
      try {
        await updateGenericData('agenda', {
          usuario,
          idUsuario: usuario?._id,
          dataAgenda: new Date(`${dados.dataExpiracao}T00:00:00`).toISOString(),
          descricaoAgenda: `Data de Expiração NS número ${dados.numeroNS}`,
          idProposta: proposta._id,
        });
        console.log('Emissão Doc — agenda criada com sucesso para', dados.dataExpiracao);
        window.alert(`Agenda de expiração criada para ${fmtData(dados.dataExpiracao)}.`);
      } catch (e) {
        console.error('Emissão Doc — erro ao criar agenda:', e);
        window.alert('Não foi possível criar a agenda de expiração da NS.');
      }
    }

    const newArray = [...(proposta.atividades || [])];
    if (criarAgenda) {
      newArray.push({
        data: new Date(),
        msg: `Documento aprovado por distribuidora - NS ${dados.numeroNS} - Emissão: ${fmtData(dados.dataEmissao)} - Expiração: ${fmtData(dados.dataExpiracao)} - Usuário: ${usuario?.nome || ''} - Agenda de expiração criada`,
      });
    }

    // Preserva o marcador da agenda já criada; grava um novo quando a agenda acabou de ser criada.
    const novoEmissaoDoc = criarAgenda
      ? { ...dados, agendaExpiracaoRef: ref }
      : { ...(proposta.emissaoDoc || {}), ...dados };
    const updatedProposta = {
      ...proposta,
      valorservico: dados.valorservico ?? proposta.valorservico,
      servicoInterno: dados.servicoInterno ?? proposta.servicoInterno,
      atividades: newArray,
      emissaoDoc: novoEmissaoDoc,
    };
    setProposta(updatedProposta);

    // Persiste na hora para o registro (e o marcador da agenda) sobreviver mesmo sem o Salvar principal.
    try {
      await updateProposta(updatedProposta);
    } catch (e) {
      // silencioso: também será persistido no Salvar principal do editor
    }

    setModalEmissaoDoc(false);
  };

  const [modalVerEquipamentos, setModalVerEquipamentos] = React.useState(false);
  const [modalPagamentoIndicador, setModalPagamentoIndicador] = React.useState(false);
  const [modalParecerAcesso, setModalParecerAcesso] = useState(false);
  const [modalEmissaoDoc, setModalEmissaoDoc] = useState(false);
  const [modalProjetoConcluido, setModalProjetoConcluido] = useState(false);
  const [modalFormularioMontagem, setModalFormularioMontagem] = useState(false);
  const [tipoAnexoMontagem, setTipoAnexoMontagem] = useState(null);
  const [valorServico, setValorServico] = useState(proposta.valorservico || '');

  const abrirModalAlocarVendedor = () => {
    if(proposta.user2 && proposta.user2?.nome !== ''){
      window.alert('Proposta já possui 2 usuários')
      return
    }
    setModalAlocar(true)
    
  }

  const handleVendedorExterno = async (newValue) => {
    const newProposta = { ...proposta };
    newProposta.user = newValue
    newProposta.user2 = proposta.user
    const newArray = [...newProposta.atividades];
    newArray.push({
      data: new Date(),
      msg: `Adicionado Usuário: ${newValue.nome}`,
    });
    // Atualize o estado da proposta
    const updatedProposta = {
      ...newProposta, // Use o estado atual como base
      atividades: newArray,
    };

    await enviaMensagem(
      'Você foi alocado em uma nova venda. Acesse a plataforma para mais informações',
      [newValue.telefone],
      updatedProposta,
      (enviadoComSucesso) => {
        if (!enviadoComSucesso) {
          window.alert('Erro ao enviar mensagem para o vendedor alocado');
        }
      }
    );

    props.onConfirm(updatedProposta, anexo);
    setModalAlocar(false)
  };

  return (
    <>
      <ThemeProvider theme={temaMarca}>
      <Box sx={style}>
        <Stack sx={{ width: '100%', backgroundColor: 'transparent' }} spacing={4}>
          <Stepper alternativeLabel activeStep={proposta.etapa?.id} connector={<QontoConnector />}
            sx={{ '& .MuiStepLabel-label': { color: cores.textoClaro, '&.Mui-active': { color: cores.textoClaro }, '&.Mui-completed': { color: cores.textoClaro } } }}>
            {steps?.etapas
              .filter(etapa => !(isFluxoSimplificado && [3,4].includes(proposta.fluxo.id) && etapa.id === 6))
              .map((etapa) => (
                <Step key={etapa.id}>
                  <StepLabel StepIconComponent={QontoStepIcon}>
                    {isFluxoSimplificado && [3,4].includes(proposta.fluxo.id) && etapa.id === 4 ? 'Projeto Concluído'
                   : isFluxoSimplificado && [3,4].includes(proposta.fluxo.id) && etapa.id === 5 ? 'Envio Montagem'
                   : etapa.nome}
                  </StepLabel>
                </Step>
              ))}
          </Stepper>
        </Stack>

        <Stack direction={'row'} gap={2} sx={{ justifyContent: 'right', mt: 2, mb: -2 }}>
          {currentLocation.pathname !== '/propostas3' &&
            proposta.fluxo.id === 2 &&
            proposta.etapa.id > 2 &&
              (((proposta.produto.nome === 'Serviços' || proposta.produto.nome === 'Proposta de Serviços') && proposta.etapa.nome === 'Negociação') || (proposta.produto.nome !== 'Serviços' && proposta.produto.nome !== 'Proposta de Serviços')) &&
              (
                <Button size="small" variant="contained" startIcon={<AddCard />} onClick={() => setModalDesconto(true)}>
                  Solicitar Desconto
                </Button>
          )}
          {(proposta.fluxo.id === 3 || proposta.fluxo.id === 4) && (
            <Button
              size="small"
              variant="contained"
              onClick={() => setModalVerEquipamentos(true)}
              sx={{ backgroundColor: cores.laranja, '&:hover': { backgroundColor: cores.laranjaEscuro } }}
            >
              Ver Equipamentos
            </Button>
          )}
         
          {proposta.fluxo.id === 3 && proposta.etapa?.id === 5 && !isFluxoSimplificado && (
            <Button
              size="small"
              variant="outlined"
              onClick={() => setModalParecerAcesso(true)}
              sx={{ borderColor: '#e65100', color: '#e65100' }}
            >
              Valor / NF / Parecer
            </Button>
          )}
          {isServico && proposta.fluxo.id === 100000000 && proposta.etapa?.id === 5 && (
            <Button
              size="small"
              variant="outlined"
              onClick={() => setModalEmissaoDoc(true)}
              sx={{ borderColor: '#1565C0', color: '#1565C0' }}
            >
              Emissão de Documentação
            </Button>
          )}
          {proposta.fluxo.id === 3 && proposta.etapa?.id === 4 && isFluxoSimplificado && (
            <Button
              size="small"
              variant="outlined"
              onClick={() => setModalProjetoConcluido(true)}
              sx={{ borderColor: '#e65100', color: '#e65100' }}
            >
              Valor / NF / Diagrama
            </Button>
          )}

          {/* Botão Formulário de Montagem — visível apenas na etapa Formulário de Montagem (id=5) */}
          {proposta.fluxo.id === 4 && proposta.etapa?.id === 5 && (
            <Button
              size="small"
              variant="outlined"
              onClick={() => setModalFormularioMontagem(true)}
              sx={{ borderColor: '#388e3c', color: '#388e3c' }}
            >
              Adicionar NF / Fotos
            </Button>
          )}

          {usuarioLogado?.supervisor && proposta.indicador && (
            <Button
              size="small"
              variant="contained"
              onClick={() => setModalPagamentoIndicador(true)}
              sx={{ backgroundColor: '#2e7d32', '&:hover': { backgroundColor: '#1b5e20' } }}
            >
              Ver Indicador
            </Button>
          )}
          {proposta.fluxo.id === 2 && currentLocation.pathname !== '/propostas3' && (
            <Button
              size="small"
              variant="contained"
              onClick={abrirModalAlocarVendedor}
            >
              Alocar Vendedor
            </Button>
          )}
          {
            proposta.motivoPersonalizado && currentLocation.pathname !== '/propostas3' &&
            <Button
              size="small"
              variant="contained"
              onClick={() => setModalPersonalizado(true)}
            >
              Ver Espeficações
            </Button>
          }
          {/* Adicionar Agenda fica disponível em todas as etapas do fluxo (lembrete de retomada de contato) */}
          <Button
            size="small"
            variant="contained"
            startIcon={<CalendarMonth />}
            onClick={() => setModalAddAgenda(true)}
          >
            Adicionar Agenda
          </Button>
          {currentLocation.pathname !== '/propostas3' && (
            <Button
              disabled={proposta.finalizado?.nome === 'Rejeitado'}
              color="error"
              size="small"
              variant="contained"
              startIcon={<BlockIcon />}
              onClick={() => setModalRejeitar(true)}
            >
              Rejeitar Proposta
            </Button>
          )}
          
          
          {currentLocation.pathname !== '/propostas3' && proposta.fluxo.id === 2 && (
            <Button
              size="small"
              variant="contained"
              startIcon={<VisibilityIcon />}
              onClick={() => setVisualizaProposta(true)}
            >
              Visualizar Proposta
            </Button>
          )}
        </Stack>

        <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} flex={1} gap={2}>
          <Stack
            alignItems={'center'}
            sx={{ width: '20%', height: '85%', maxHeight: '80vh', border: 1, borderRadius: 2 }}
          >
            <Stack alignItems={'center'} sx={sxTituloPainel}>
              <b>Backlog</b>
            </Stack>
            <Box maxHeight="90%">
              <Box
                maxHeight="100%"
                height="100%"
                overflow="auto"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Stepper activeStep={proposta.etapa?.id - 1} orientation="vertical"
                  sx={{ '& .MuiStepLabel-label': { color: cores.textoClaro, '&.Mui-active': { color: cores.textoClaro }, '&.Mui-completed': { color: cores.textoClaro } } }}>
                  {proposta.backlog
                    ?.find((fluxo) => fluxo.id === proposta.fluxo.id)
                    ?.etapas?.map((step) => (
                      <Step key={step.id}>
                        <StepLabel>
                          {step.nome}
                          <br />
                          {new Date(step.data).toLocaleDateString()}
                        </StepLabel>
                      </Step>
                    ))}
                </Stepper>
              </Box>
            </Box>
          </Stack>

          <Stack alignItems={'center'} sx={{ width: '50%', height: '85%', border: 1, borderRadius: 2 }}>
            <Stack
              alignItems={'center'}
              sx={{ ...sxTituloPainel, maxHeight: '80vh' }}
            >
              <b>Atividades</b>
            </Stack>
            <AtividadesPainel
              atividades={proposta.atividades}
              onAdd={() => setModalAtividade(true)}
              height="55vh"
              filterFn={(atividade) => !(currentLocation.pathname === '/propostas3' && !atividade.instalacao)}
              extraTop={
                trocaDisjuntor ? (
                  <Typography
                    variant="subtitle2"
                    sx={{ backgroundColor: 'Khaki', width: '100%', borderRadius: 2, p: 0.5 }}
                  >
                    {`ATENÇÃO: Será necessário efetuar a troca do disjuntor do cliente`}
                  </Typography>
                ) : null
              }
            />
          </Stack>
          <Stack alignItems={'center'} sx={{ width: '30%', height: '85%', border: 1, borderRadius: 2 }}>
            <Stack alignItems={'center'} sx={sxTituloPainel}>
              <b>Anexos</b>
            </Stack>
            <Stack direction={'row'}>
              <Button
                sx={{ ...sxFontBotaoMobile, mt: 2, mb: 2 }}
                size={'small'}
                onClick={() => setModalAddAnexo(true)}
                variant="contained"
              >
                Adicionar Anexo
              </Button>
              {!isServico && (
                <Button
                  sx={{ ...syleinformation, ml: 2 }}
                  size={'small'}
                  onClick={() => setModalValidaAnexos(true)}
                  variant="outlined"
                >
                  !
                </Button>
              )}
            </Stack>

            <Container sx={{ height: '55vh', overflowY: 'auto', backgroundColor: cores.branco, borderRadius: 2, p: 1, width: '100%' }}>
              {anexo?.map((anexo, index) => {
                // No módulo Montagem (/propostas3): mostrar apenas anexos permitidos
                // ── Lógica de visibilidade de anexos por perfil ─────────────
                const isSupervisor  = usuarioLogado?.supervisor;
                const isMontador    = usuarioLogado?.montador;
                // Engenheiro: tem módulo 2 ativo OU acessa pela rota de engenharia
                const temModulo2    = usuarioLogado?.modulos?.some(m => m.id === 2 && m.ativo);
                const isEngenheiro  = !isSupervisor && !isMontador && (temModulo2 || currentLocation.pathname === '/propostas2');
const idLogado      = usuarioLogado?._id?.toString() || usuarioLogado?.id?.toString();
                const idAnexou      = anexo.useranexo?._id?.toString() || anexo.useranexo?.id?.toString();
                const foiQuemAnexou = idLogado && idAnexou && idLogado === idAnexou;
                const nomeAnexo     = anexo.tipo?.nome;

                // Montador
                if (isMontador) {
                  const tiposLivres = ['Diagrama Unifilar', 'Localização', 'Fachada da Casa'];
                  const tiposSeus   = ['Nota Fiscal de Montagem', 'Foto de Montagem'];
                  const podeVer = tiposLivres.includes(nomeAnexo) ||
                    (tiposSeus.includes(nomeAnexo) && (foiQuemAnexou || anexo.instalacao));
                  if (!podeVer) return null;
                }
                // Engenheiro — não vê apenas NF de Montagem
                if (isEngenheiro) {
                  const tiposOcultos = ['Nota Fiscal de Montagem', 'Contrato Assinado'];
                  if (tiposOcultos.includes(nomeAnexo)) return null;
                }
                return (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography
                      key={index}
                      onClick={() => downloadAnexo(anexo)}
                      variant="subtitle2"
                      sx={{
                        backgroundColor: 'transparent',
                        ml: 1,
                        mb: 1,
                        '&:hover': {
                          backgroundColor: '#f0f0f0',
                          cursor: 'pointer',
                        },
                      }}
                    >
                      {anexoToChange !== index ? (
                        `${index + 1} - ${anexo.nome}`
                      ) : (
                        <TextField
                          size="small"
                          sx={{ '& input': { fontSize: '0.8rem' } }}
                          id="nome"
                          label="Nome"
                          variant="outlined"
                          value={newName}
                          onChange={(e) => changeName(e)}
                        />
                      )}
                    </Typography>
                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
                      <>
                        <IconButton onClick={() => handleDelete({ ...anexo, index })} sx={{ cursor: 'pointer', color: '#555' }}>
                          <DeleteIcon sx={{ fontSize: '20px' }} />
                        </IconButton>
                        <IconButton onClick={() => handleChangeAnexo({ ...anexo, index })} sx={{ cursor: 'pointer', color: '#555' }}>
                          <EditIcon sx={{ fontSize: '20px' }} />
                        </IconButton>
                      </>
                    </div>
                  </div>
                );
              })}
            </Container>
          </Stack>
        </Stack>

        <Stack direction={'row'} justifyContent={'space-between'} sx={{ bottom: -100, left: 0, right: 0, p: 2 }}>
          <Button sx={sxFontBotaoMobile} size={'small'} variant="outlined" onClick={() => onClose()} color="error">
            {' '}
            Cancelar
          </Button>
          <Button
            sx={sxFontBotaoMobile}
            size={'small'}
            disabled={proposta.etapa?.id === 0 || proposta.finalizado?.nome === 'Rejeitado'}
            variant="contained"
            onClick={handleBack}
            startIcon={<ArrowBackIosNewIcon />}
          >
            Anterior
          </Button>
          <Button
            sx={sxFontBotaoMobile}
            size={'small'}
            disabled={proposta.finalizado?.nome === 'Rejeitado'}
            variant="contained"
            onClick={handleNext}
            endIcon={<ArrowForwardIosIcon />}
          >
            Próximo
          </Button>
          <Button
            sx={sxFontBotaoMobile}
            size={'small'}
            disabled={proposta.finalizado?.nome === 'Rejeitado'}
            variant="outlined"
            color="success"
            onClick={handleConfirm}
            startIcon={<SaveIcon />}
          >
            Salvar
          </Button>
        </Stack>
      </Box>
      </ThemeProvider>

      {/* Modal Mensagem */}
      <ModalMensagem open={modalMensagem} onClose={closeModalMensagem} />

      {/* Modal Projeto Concluído — Bombeamento */}
      {modalProjetoConcluido && (
        <ModalProjetoConcluido
          open={modalProjetoConcluido}
          onClose={() => setModalProjetoConcluido(false)}
          proposta={proposta}
          setProposta={setProposta}
          anexo={anexo}
          onAddAnexo={(tipo) => {
            setModalProjetoConcluido(false);
            setModalAddAnexo(true);
          }}
        />
      )}

      {/* Modal Muda Fluxo */}
      <ModalMudaFluxo open={modalMudaFluxo} onClose={closeModalMudaFluxo} onConfirm={handleMudaFluxo} />

      {/* Modal Atividade */}
      <ModalAtividadade open={modalAtividade} onClose={closeModalAtividade} onConfirm={handleSalvarAtividade} />

      {/* Modal Visualiza Proposta */}
      {visualizaProposta ? (
        <EditProposta open={visualizaProposta} proposta={proposta} onClose={onCloseVisualiza} visualiza />
      ) : null}
      {/* Modal Rejeitar Proposta */}
      {modalRejeitar ? (
        <ModalRejeitarProposta
          open={modalRejeitar}
          onClose={() => setModalRejeitar(false)}
          onConfirm={rejeitarProposta2}
          onAutoCompleteChange={handleAutoCompleteChange}
          proposta={proposta}
        />
      ) : null}
      {/* Modal Responsável */}
      {modalResponsavel ? (
        <ModalResponsavel
          open={modalResponsavel}
          onClose={() => setModalResponsavel(false)}
          onConfirm={responsavelProposta}
        />
      ) : null}
      {/* Modal Forma de Pagamento */}
      {modalPagamento ? (
        <ModalPagamento
          open={modalPagamento}
          onClose={cancelarPagamento}
          onConfirm={pagamentoProposta}
          formapagamento={proposta.formapagamento}
        />
      ) : null}
      {/* Modal Confirmacao */}
      {modalConfirmacaoDelete ? (
        <ModalConfirmacao
          title={'Tem certeza que deseja excluir esse anexo?'}
          open={modalConfirmacaoDelete}
          onClose={closeModalConfirmacaDelete}
          onConfirm={confirmDeleteAnexo}
        />
      ) : null}
      {/* Modal Montador */}
      {modalMontador ? (
        <ModalMontador open={modalMontador} onClose={() => setModalMontador(false)} onConfirm={montadorProposta} />
      ) : null}
      {/* Modal Valor Montagem */}
      {modalValorMontagem ? (
        <ModalValorMontagem open={modalValorMontagem} onClose={cancelarPagamento} onConfirm={valorMontagem} />
      ) : null}

      {/* Modal Tipo Contratante */}
      {modalTipoContratante ? (
        <ModalTipoContratante
          open={modalTipoContratante}
          onClose={cancelarTipoContratante}
          onConfirm={handletipoContratante}
        />
      ) : null}

      {/* Modal Add Anexo */}
      {modalAddAnexo ? (
        <ModalAddAnexo
          open={modalAddAnexo}
          onClose={() => setModalAddAnexo(false)}
          onConfirm={addNewAnexo}
          anexos={anexo}
          tipocontratante={proposta.tipocontratante}
          anexo={anexoToChange}
          notafiscal={(proposta.fluxo?.id === 3 && proposta.etapa?.id === 5) || (proposta.fluxo?.id === 100000000 && proposta.etapa?.id === 5)}
          montagem={proposta.fluxo?.id === 4 && proposta.etapa?.id === 5}
          tipoAnexoMontagem={tipoAnexoMontagem}
          isBombeamento={isBombeamento}
          isOffGrid={isOffGrid}
          isServico={isServico}
        />
      ) : null}

      {/* Modal Valida Anexos */}
      {modalValidaAnexos ? (
        <ModalValidaAnexos
          open={modalValidaAnexos}
          onClose={() => setModalValidaAnexos(false)}
          onConfirm={() => setModalValidaAnexos(false)}
          anexos={anexo}
          tipocontratante={proposta.tipocontratante}
          isBombeamento={isBombeamento}
          isOffGrid={isOffGrid}
        />
      ) : null}
      {/* Modal Desconto */}
      {modalDesconto && (
        <ModalDesconto open={modalDesconto} onClose={() => setModalDesconto(false)} onConfirm={solicitarDesconto} onVisualiza={() => setVisualizaProposta(true)} proposta={proposta}/>
      )}
      {
        modalAddAgenda && (
          <ModalAddAgenda open={modalAddAgenda} onClose={() => setModalAddAgenda(false)} proposta={proposta} onConfirmAgenda={handleAddAgenda}/>
        )
      }
      {
        modalPersonalizado && 
        <ModalPropostaPersonalizada
          open={modalPersonalizado}
          onClose={() => setModalPersonalizado(false)}
          proposta={proposta}
          onConfirm={() => setModalPersonalizado(false)}
        />
      }
      {modalParecerAcesso && (
        <ModalParecerAcesso
          open={modalParecerAcesso}
          onClose={() => setModalParecerAcesso(false)}
          proposta={proposta}
          setProposta={setProposta}
          anexo={anexo}
          onAddAnexo={(tipo) => {
            setModalParecerAcesso(false);
            setModalAddAnexo(true);
          }}
        />
      )}

      {modalEmissaoDoc && (
        <ModalEmissaoDocumentacao
          open={modalEmissaoDoc}
          onClose={() => setModalEmissaoDoc(false)}
          proposta={proposta}
          setProposta={setProposta}
          anexo={anexo}
          onAddAnexo={() => {
            setModalEmissaoDoc(false);
            setModalAddAnexo(true);
          }}
          onConfirmEmissao={handleConfirmEmissaoDoc}
        />
      )}

      {modalPagamentoIndicador && (
          <ModalPagamentoIndicador
            open={modalPagamentoIndicador}
            onClose={() => setModalPagamentoIndicador(false)}
            proposta={proposta}
          />
        )}

      {modalVerEquipamentos && (
        <ModalVerEquipamentos
          open={modalVerEquipamentos}
          onClose={() => setModalVerEquipamentos(false)}
          proposta={proposta}
        />
      )}
      {
        modalAlocar && 
        <ModalAlocarVendedor
          open={modalAlocar}
          onClose={() => setModalAlocar(false)}
          proposta={proposta}
          onConfirm={handleVendedorExterno}
        />
      }

      {modalFormularioMontagem && (
        <ModalFormularioMontagem
          open={modalFormularioMontagem}
          onClose={() => setModalFormularioMontagem(false)}
          anexo={anexo}
          proposta={proposta}
          setProposta={setProposta}
          onAddAnexo={(tipo) => {
            setModalFormularioMontagem(false);
            setAnexoToChange(null);
            // Define o tipo pré-selecionado conforme o botão clicado
            setModalAddAnexo(true);
            setTipoAnexoMontagem(tipo);
          }}
        />
      )}
    </>
  );
});

EditFluxo.propTypes = {
  produto: PropTypes.object,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onClose: PropTypes.func,
};

export default EditFluxo;